import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from "react";
export function useScrolled(thresholdTop, thresholdBottom) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isScrolled = _useState2[0],
      setIsScrolled = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isScrolledToBottom = _useState4[0],
      setIsScrolledToBottom = _useState4[1];

  useEffect(function () {
    var scrollHandler = function scrollHandler(e) {
      var _e$target$scrollingEl = e.target.scrollingElement,
          scrollHeight = _e$target$scrollingEl.scrollHeight,
          scrollTop = _e$target$scrollingEl.scrollTop,
          clientHeight = _e$target$scrollingEl.clientHeight;

      if (scrollTop > thresholdTop) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }

      if (scrollHeight - scrollTop - thresholdBottom < clientHeight) {
        setIsScrolledToBottom(true);
      } else {
        setIsScrolledToBottom(false);
      }
    };

    document.addEventListener("scroll", scrollHandler);
    return function () {
      document.removeEventListener("scroll", scrollHandler);
    };
  }, [thresholdBottom, thresholdTop]);
  return [isScrolled, isScrolledToBottom];
}